import router from '@/router'
import cmd from '@/common/Command'

const GeographModule = {
  namespaced: true,
  state: {
    rows: [],
    content: {}
  },
  mutations: {
    setRows (state, value) {
      state.rows = value
    },
    setContent (state, value) {
      state.content = value
    }
  },
  actions: {
    //前ページ
    prevAction ({ commit, state, rootState }) {
      router.go(-1)
    },
    //
    search ({ commit, state, rootState }) {

      if (state.rows.length != 0) {
        return
      }

      function callback(rows){
        var list = []
        $.each(rows, function(idx, row){
          if (row != "") {
            list.push({"id": row[0], "title" : row[1], "area": row[2], "url": row[3], "expl": row[4]})
          }
        })
        commit('setRows', list)
      }
      cmd.getData("geographical", callback)

    },
    //次ページ
    showDetail ({ commit, state, rootState }, id) {

      //対象コンテンツを取得
      var content = {}
      $.each(state.rows, function(idx, row){
        if (row.id == id) {
          content.id = row.id
          content.title = row.title
          content.area = row.area
          content.expl = row.expl
          return false
        }
      })

      //
      commit('setContent', content)

      router.push('geographicalDetail', () => {})
    },
    returnToIndex ({ commit, state, rootState }) {
      router.push('geographical')
    }

  },
  getters: {
    rows (state, getters, rootState) {
      return state.rows
    },
    content (state, getters, rootState) {
      return state.content
    }

  }
}

export default GeographModule



// WEBPACK FOOTER //
// ./src/store/modules/GeographModule.js